import {CaseItem} from './jcal-case-item';

export const caseGroupEntities: CaseItem [] = [
   {   id: 1,
        route: '',
        zylyType: '摄像头',
        title: '摄像头应用产品',
        titleimage:'', 
       contents: [{
            id: 1, itemClass: '1', paragraph: '摄像头',  itemimage:'',
            values: [   
                {   id: 1, value: '采用720P高清视频低码流传输，最大限度节省流量;智能的日夜模式切换，能够自动开启红外夜视功能。'
                    + '与此同时，采用专业摄像技术，在大反差光线、逆光和低亮度环境下，仍然能提供清晰图像。'
                    + '而且，它还内置麦克风、扬声器，支持双向语音对讲。以家为重心的设计理念，摒弃专业摄像头设计，小巧可爱的外观，自然融入家中。',
                    valimage:'assets/image/cp_xfl_jysxt.jpg'},                
            ],
        },
         {
            id: 2, itemClass: '2', paragraph: '应用场景一',itemimage:'',
            values:[
                {   id: 1, value: '室外场景，自动曝光调节，高还原度。',
                    valimage:'assets/image/cp_xfl_jysxt_swcj.jpg'},   
        ],},
        {
            id: 3, itemClass: '2', paragraph: '应用场景二',itemimage:'',
            values:[
                {   id: 1, value: '随时实地了解家中宝宝动向，看护老人安全，监护宠物动向。',
                valimage:'assets/image/cp_xfl_jysxt_jtjh.jpg'}, 
        ],},
        {
            id: 4, itemClass: '2', paragraph: '应用场景三',itemimage:'',
            values:[
                {   id: 1, value: '太阳能摄像，用于农场、院子、学校、鱼塘、果园、矿山、建筑工地等所有不方便接通市电电源但室外阳光充足的地方。',
                valimage:'assets/image/cp_xfl_jysxt_tyn.jpg'}, 
        ],},
        ],
    },

    {   id: 2,
        route: '',
        zylyType: '血氧仪',
        title: '血氧仪应用产品',
        titleimage:'',  
       contents: [{
            id: 1, itemClass: '1', paragraph: '蓝牙血氧仪',  itemimage:'',
            values: [   
                {id: 1, value: '蓝牙血氧仪用于医院、诊所和家庭的低功耗蓝牙指尖脉搏血氧仪，精确测量病患的血氧饱和度（SpO2）、脉搏率(PR)和血流灌注指数（PI）。'
                    + '血氧饱和度指标是反映呼吸循环的重要生理参数，而血流灌注指数是通过身体四肢小血管的血流量的测量数据。',
                    valimage:'assets/image/cp_xfl_xty.jpg'},                
            ],
        },         
        ],
    },

    {   id: 3,
        route: '',
        zylyType: '智能门锁',
        title: '智能门锁应用产品',
        titleimage:'', 
       contents: [{
            id: 1, itemClass: '1', paragraph: '智能门锁',  itemimage:'',
            values: [ 
                {id: 1, value: '智能门锁是指区别于传统机械锁的基础上改进的，在用户安全性、识别、管理性方面更加智能化简便化的锁具。智能门锁是门禁系统中锁门的执行部件。',
                valimage:'assets/image/cp_xfl_znms.jpg'},                
            ],
        },         
        ],
    }, 

    {   id: 4,
        route: '',
        zylyType: '智能插排',
        title: '智能插排应用产品',
        titleimage:'', 
       contents: [{
            id: 1, itemClass: '1', paragraph: '智能插排',  itemimage:'',
            values: [ 
                {id: 1, value: '智能插座又可以称为 WIFI 插座，在普通插座的功能基础上延伸了许多功能，如防雷击，防短路，防过载，防漏电，配合智能手机的 APP 应用，'
                + '可以实现远程开关控制、定时开关、随时了解家电设备的使用状况。',
                valimage:'assets/image/cp_xfl_jysxt_znpc.jpg'},      
                {id: 2, value: '    --内置 Timer 进行解码红外输入。',
                valimage:''},   
                {id: 3, value: '    --通过串口与云端连接，进行远程控制，以及电量监控等。',
                valimage:''},   
                {id: 4, value: '    --通过 I2C 与计量芯片通讯，进行异常检测，过流，过/欠压等保护。',
                valimage:''},             
            ],
        },         
        ],
    }, 

    {   id: 5,
        route: '',
        zylyType: '洗衣机',
        title: '洗衣机应用产品',
        titleimage:'', 
       contents: [{
            id: 1, itemClass: '1', paragraph: '洗衣机',  itemimage:'',
            values: [ 
                {id: 1, value: '洗衣机是利用电能产生机械作用来洗涤衣物的清洁电器，按驱动方法有 3 类，直接驱动，皮带驱动，波轮式驱动。',
                valimage:'assets/image/cp_xfl_xyj.jpg'},      
                {id: 2, value: '    --可靠低速快速启动',
                valimage:''},   
                {id: 3, value: '    --稳定的高速运行',
                valimage:''},   
                {id: 4, value: '    --快速刹车控制',
                valimage:''},             
            ],
        },         
        ],
    }, 

/*
    {   id: 6,
        route: '',
        zylyType: '通信类',
        title: '通信类路由器应用产品',
        titleimage:'', 
       contents: [
           {
            id: 1, itemClass: '1', paragraph: '特点',  itemimage:'',
            values: [ 
                {id: 1, value: '独立的信号放大器能有效的增强信号发射功率，同时提高信号接收灵敏度。超强穿墙效果，覆盖更多的房间。'
                    + '当更高速度的带宽接入时，能够充分发挥其优势，使无线传输速率不再受到有线端口速率的限制'
                    + '，为无线终端提供更为流畅的网络享受。大幅提升无线性能，同时提高信号强度，增大覆盖范围，增强连接稳定性。' ,
                valimage:'assets/image/cp_txl_lyq.jpg'},      
               ],
            }, 
            {
                id: 1, itemClass: '1', paragraph: '结构',  itemimage:'',
                values: [ 
                    {id: 1, value: '电源接口（POWER）：接口连接电源。',
                    valimage:''},
                    {id: 1, value: '复位键（RESET）：此按键可以还原路由器的出厂设置。',
                    valimage:''},
                    {id: 1, value: '猫(MODEM)或者是交换机与路由器连接口（WAN）：此接口用一条网线与家用宽带调制解调器（或者与交换机）进行连接。'
                        + '电脑与路由器连接口（LAN1~4）：此接口用一条网线把电脑与路由器进行连接。',
                    valimage:''},
                ],
            }, 
            {
                id: 2, itemClass: '1', paragraph: '应用场景一',  itemimage:'',
                values: [ 
                    {id: 1, value: '体育场级强劲信号覆盖。',
                    valimage:''},
                ],
            }, 
            {
                id: 2, itemClass: '1', paragraph: '应用场景二',  itemimage:'',
                values: [ 
                    {id: 1, value: '适用于高带宽入户家庭的高清视频点播、家庭内部数据高速传输共享等应用，以及手机、Pad、机顶盒、笔记本等无线终端较多的家庭使用。',
                    valimage:''},
                ],
            },
        ],
    }, 


    {   id: 7,
        route: '',
        zylyType: 'MCU',
        title: 'MCU应用产品',
        titleimage:'', 
       contents: [
           {
            id: 1, itemClass: '1', paragraph: '',  itemimage:'',
            values: [ 
                {id: 1, value: '广泛应用在工业控制、家庭电器、智能设备、手机和电脑等智能终端。' ,
                valimage:'assets/image/cp_mcu.jpg'},      
               ],
            }, 
            {
                id: 1, itemClass: '1', paragraph: 'MCU在工控中的应用',  itemimage:'assets/image/cp_mcu_gykz.jpg',
                values: [ 
                    {id: 1, value: 'MCU能有效改善工业控制的系统性能和能耗，可以实现具有以下特点的解决方案：',
                    valimage:''},
                    {id: 2, value: '    1、能量效率能够总是保持最佳速度与扭矩；',
                    valimage:''},
                    {id: 3, value: '    2、更好的系统性能——低噪声与低振动，运行平稳，启动和停止时也很平稳。',
                    valimage:''},
                    {id: 4, value: '    3、有效改善元器件模式的缺陷：',
                    valimage:''},
                    {id: 5, value: '        -- 元器件多 -> MCU芯片集成度高；',
                    valimage:''},
                    {id: 6, value: '        -- 元器件占用面积大 -> MCU芯片有效简化外围电路，节省空间；',
                    valimage:''},
                    {id: 7, value: '        -- 元器件开发复杂、周期长 -> MCU简化设计、开发周期短',
                    valimage:''},

                ],
            }, 
            {
                id: 2, itemClass: '1', paragraph: 'MCU在家电中的应用',  itemimage:'',
                values: [ 
                    {id: 1, value: 'MCU广泛应用在洗衣机、空调、微波炉、吸尘器、电冰箱等多种家用电器中。MCU可主要用于电机控制、模拟传感器测量、前面板键盘控制以及在LED/LCD上显示结果等。',
                    valimage:''},
                ],
            }, 
            {
                id:3, itemClass: '1', paragraph: 'MCU在手机和电脑上的应用',  itemimage:'',
                values: [ 
                    {id: 1, value: 'MCU在当前手机与平板电脑应用中主要用作诸如电容式触摸感应接口、触摸屏接口、摄像头接口、不同模拟传感器输入检测、USB接口以及电池充电与监控等众多功能的协处理器。',
                    valimage:''},
                ],
            },

            {
                id:3, itemClass: '1', paragraph: 'MCU的其他应用',  itemimage:'',
                values: [ 
                    {id: 1, value: '无人机、额温枪、智能锁、激光扫码枪、智能家居网关、血氧仪。',
                    valimage:''},
                ],
            },
 
        ],
    },
*/
];

